/**
 * relacionados.js — helpers puros de artículos relacionados.
 *
 * La relación es de ida y vuelta, pero se guarda de un solo lado: si A tiene a B en
 * `relacionadosIds`, B también muestra a A. La vuelta se calcula al mostrar, así nunca
 * queda un par a medias.
 */

/** Ids de los artículos que tienen a `artId` en su lista de relacionados. */
export function relacionadosInversos(artId, articulos) {
  return articulos
    .filter(a => a.id !== artId && Array.isArray(a.relacionadosIds) && a.relacionadosIds.includes(artId))
    .map(a => a.id);
}

/** Ids relacionados en los dos sentidos: primero los propios (en su orden), después los inversos. Sin repetidos. */
export function relacionadosDe(art, articulos) {
  const propios = Array.isArray(art.relacionadosIds) ? art.relacionadosIds : [];
  return [...new Set([...propios, ...relacionadosInversos(art.id, articulos)])].filter(id => id !== art.id);
}

/**
 * Qué guardar al confirmar el diálogo de relacionados.
 *  - propios: lista nueva del artículo. Lo que ya venía de otro artículo y sigue marcado
 *    no se copia (la vuelta ya lo muestra), salvo que estuviera guardado también de este lado.
 *  - quitarDe: [{ id, relacionadosIds }] artículos que lo tenían en su lista y se desmarcaron;
 *    `relacionadosIds` es la lista nueva de ese artículo (null si queda vacía).
 */
export function planRelacionados(art, articulos, seleccionados) {
  const elegidos = new Set(seleccionados);
  const originales = new Set(Array.isArray(art.relacionadosIds) ? art.relacionadosIds : []);
  const inversos = new Set(relacionadosInversos(art.id, articulos));

  const propios = [...elegidos].filter(id => id !== art.id && (originales.has(id) || !inversos.has(id)));
  const quitarDe = articulos
    .filter(a => inversos.has(a.id) && !elegidos.has(a.id))
    .map(a => {
      const resto = a.relacionadosIds.filter(id => id !== art.id);
      return { id: a.id, relacionadosIds: resto.length ? resto : null };
    });

  return { propios, quitarDe };
}
